<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('shortlinks')"
      :columns="columns"
      :column_search="true"
      resource_url="/shortlink/link/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <link-modal ref="link_modal" @success="refresh" />
    <log-modal ref="log_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date_time,
  success_message,
} from "@/utils";
import LinkModal from "./link_modal/Index.vue";
import LogModal from "./log_modal/Index.vue";

export default {
  name: "LinksDatatable",
  components: { GenericTable, LinkModal, LogModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("create date"),
          width: "15%",
          data: (row) => format_date_time(row.create_date),
        },
        {
          title: v.$t("profile"),
          searchable: false,
          data: (row) => row.profile.name,
        },
        {
          title: v.$t("original url"),
          searchable: false,
          data: (row) => row.original_url,
        },
        {
          title: v.$t("short url"),
          searchable: false,
          data: (row) => row.short_url || "",
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { url: row.short_url },
                tooltip: v.$t("copy link"),
                icon: "fa fa-copy",
                icon_class: "is-small",
                click: function (e) {
                  navigator.clipboard.writeText(row.short_url).then(() => {
                    success_message(v.$t("copied to clipboard"));
                  });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.link_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("log"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.log_modal.show(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete link?"),
                    v,
                    () => {
                      del("/shortlink/link", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date_time,
    create() {
      let v = this;
      v.$refs.link_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
